import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckboxAnswer } from '../../../../team-apis/otterdam/answers/checkbox-answer';
import { CheckboxOutput } from '../../../../team-apis/otterdam/outputs/checkbox-output';
import { AbstractNestableOutputComponent } from '../abstract-nestable-output.component';

@Component({
  selector: 'h3-checkbox-output',
  templateUrl: './checkbox-output.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckboxOutputComponent extends AbstractNestableOutputComponent<
  CheckboxOutput,
  CheckboxAnswer
> {}
